import { EventItem, Icon, Body, Label, Code, Detail } from './EventItem';
EventItem.displayName = "EventItemBase";
Icon.displayName = "EventItem.Icon";
Body.displayName = "EventItem.Body";
Label.displayName = "EventItem.Label";
Detail.displayName = "EventItem.Detail";
Code.displayName = "EventItem.Code";
export { EventItem as default, Icon, Body, Label, Code, Detail };